<template>
    <div style="background-color: black;">
        <!-- 航空动力 -->
        <!-- <div class="title" ref="title">
            <transition name="text" appear>
                <div class="textArea">
                    绿色能源
                </div>
            </transition>
        </div> -->
        <div style="height: 100vh;background-color: black;">
            <video autoplay muted class="background-video" id="backVideo" ref="videoElement" loop>
                <source :src=videoSrc type="video/mp4" />
            </video>
            <!-- <video-background :video-src="require('@/assets/index/back.mp4')"> -->
            <div class="logo">
                <transition name="text" appear>
                    <div class="textArea">
                        绿色能源
                    </div>
                </transition>
            </div>
        </div>
        <div class="energy">
            <div class="ny turbine" ref="turbine">
                <div class="left">
                    <el-tabs tab-position="left" class="custom-tabs" v-model="energyList.turbine.activeName"
                        @tab-click="handTabClick($event, energyList.turbine)" type="horizontal">
                        <el-tab-pane label="产品介绍" name="产品介绍">
                            <div class="parameter" style="margin-left: 10%;">
                                <transition name="importance" appear v-if="energyList.turbine.importance">
                                    <div style="margin-top: 30%;text-align: justify;text-indent: 2em;">
                                        <span>清航系列燃机目前有GT200、GT200-H、BZGT600、BZGT1200等系列，能够实现燃油-燃氢-纯氢爆震燃烧，燃料适应性广，氮氧化物排放最低达10ppm内，综合能源效率最高高达85%以上。兼具体积小、重量轻、发电效率高、启停速度快、超长寿命及高可靠性等优势，适用于分布式发电、备用电源、调峰、热电联产等场景。</span>
                                    </div>
                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="energyList.turbine.all">
                                <el-table :data="energyList.turbine.allParameters" class="parameterTable"
                                    style="background-color: red;margin-left: 20%;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right">
                    <div class="name">
                        <p class="paramName">先进燃气轮机</p>
                    </div>
                    <div class="product">
                        <video autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/energy/NY页面1.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton"
                        @click="downFile">产品手册下载</el-button>
                </div>
            </div>

            <div class="ny burner" ref="burner">
                <div class="right">
                    <div class="name">
                        <p class="paramName">新型燃烧器</p>
                    </div>
                    <div class="product">
                        <video autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/energy/NY页面2.mp4')" type="video/mp4" />
                        </video>
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton"
                        @click="downFile">产品手册下载</el-button>
                </div>
                <div class="left">
                    <el-tabs tab-position="right" class="custom-tabs" v-model="energyList.burner.activeName"
                        @tab-click="handTabClick($event, energyList.burner)" type="horizontal">
                        <el-tab-pane label="产品介绍" name="产品介绍">
                            <div class="parameter" style="margin-right: 10%;">
                                <transition name="importance" appear v-if="energyList.burner.importance">
                                    <div style="text-align: justify;margin-top: 30%;text-indent: 2em;">
                                        工业燃烧器系列主要包含应用爆震燃烧技术的EG201、EG202、HOH105三个型号，其中EG201主要应用于工业供热场景，EG202与燃机相结合应用于电站场景，HOH105实现富氢燃烧，应用于氢气加热、焚烧、冶金等领域。受益于爆震燃烧技术的快速燃烧反应，相关类型的燃烧器具备超低氮氧化物和高燃烧效率等优点，在燃机排放标准下，NOX排放值可实现低于5ppm超低排放。
                                    </div>
                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="energyList.burner.all">
                                <el-table :data="energyList.burner.allParameters" class="parameterTable"
                                    style="background-color: red;" :span-method="objectSpanMethod">
                                    <el-table-column prop="model" label="型号">
                                    </el-table-column>
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="ny electrical" ref="electrical">
                <div class="left">
                    <el-tabs tab-position="left" class="custom-tabs" v-model="energyList.electrical.activeName"
                        @tab-click="handTabClick($event, energyList.electrical)" type="horizontal">
                        <el-tab-pane label="产品介绍" name="产品介绍">
                            <div class="parameter" style="margin-left: 10%;">
                                <transition name="importance" appear v-if="energyList.electrical.importance">
                                    <div style="margin-top: 30%;margin-left: 9%;text-align: justify;text-indent: 2em;">
                                        <span>清航系列高速电机使用非接触薄膜润滑系统，研发出核心技术“空气-电磁混合式非接触轴承”、高速启发一体驱动等核心技术，为燃气轮机核心机微型化和低成本量产提出了可靠解决途径。高速电机总体效率不低于96%，额定转速高达25000r/min，同时应用场景广泛，可根据应用场景进行定制开发。</span>
                                    </div>
                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(55%);">
                            <transition name="all" appear v-if="energyList.electrical.all">
                                <el-table :data="energyList.electrical.allParameters" class="parameterTable"
                                    style="background-color: red;margin-left: 20%;">
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>

                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="right">
                    <div class="name">
                        <p class="paramName" style="text-align: center;">电机一站式</p>
                        <p class="paramName">节能解决方案</p>
                    </div>
                    <div class="product">
                        <video autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/energy/NY页面3.mp4')" type="video/mp4" />
                        </video>
                        <!-- <img :src="require('@/assets/energy/高速电机.png')" style="height: 100%;"> -->
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton"
                        @click="downFile">产品手册下载</el-button>
                </div>
            </div>

            <div class="ny motor" ref="motor">
                <div class="right">
                    <div class="name">
                        <p class="paramName"> 高速叶轮机械产品</p>
                    </div>
                    <div class="product">
                        <video autoplay muted loop class="backgroundVideo">
                            <source :src="require('@/assets/energy/能源页面4.mp4')" type="video/mp4" />
                        </video>
                        <!-- <img :src="require('@/assets/energy/高速叶轮.png')" style="height: 100%;"> -->
                    </div>
                    <el-button type="primary" icon="el-icon-download" class="downloadButton"
                        @click="downFile">产品手册下载</el-button>
                </div>
                <div class="left">
                    <div style="text-align: justify;margin-top: 30%;width: 80%;text-indent: 2em;font-size: 26px;">
                        <span>清航系列悬浮风机集成箔片空气轴承，高速永磁电机，高效率叶轮等核心技术，具有占地小，自适应监测调控，噪声低，节能高效，免调控等特点，可实现远程物联网通信，适用于多种工业应用场景。
                        </span>
                    </div>
                    <!-- <el-tabs tab-position="right" class="custom-tabs" v-model="energyList.motor.activeName"
                        @tab-click="handTabClick($event, energyList.motor)" type="horizontal">
                        <el-tab-pane label="产品介绍" name="产品介绍">
                            <div class="parameter" style="margin-right: 10%;">
                                <transition name="importance" appear v-if="energyList.motor.importance">
                                    <div style="text-align: justify;margin-top: 5%;">
                                        <p>空气悬浮离心鼓风机优势</p>
                                        <p>1、优化的整体设计(箔片空气轴承，高永磁电机，高效率叶轮)，稳定可靠的运转。玉力、温度、流量等运行参数，多种运行模式，可实现远程</p>
                                        <p>2、智能控制系统(PLC)采集和监测系统物联网通信。</p>
                                        <p>3、主要特点:占地小，多种运行方式，声低，效率高，免维护等。</p>
                                    </div>
                                </transition>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="全部参数" name="全部参数" style="scale: 0.8;transform: translateY(-12%);">
                            <transition name="all" appear v-if="energyList.motor.all">
                                <el-table :data="energyList.motor.allParameters" class="parameterTable"
                                    style="background-color: red;" :span-method="objectSpanMethod">
                                    <el-table-column prop="model" label="型号">
                                    </el-table-column>
                                    <el-table-column prop="name" label="技术指标">
                                    </el-table-column>
                                    <el-table-column prop="value" label="参数">
                                    </el-table-column>
                                    <el-table-column prop="unit" label="单位">
                                    </el-table-column>
                                </el-table>
                            </transition>
                        </el-tab-pane>
                    </el-tabs> -->
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            id: 'title',
            distance: 0,
            videoSrc: require('@/assets/energy/untitled.30.mp4'),
            energyList: {
                turbine: {
                    importance: true,
                    all: false,
                    activeName: '产品介绍',
                    previousName: '产品介绍',
                    allParameters: [
                        {
                            name: '额定电功率',
                            value: '230',
                            unit: 'kW'
                        }, {
                            name: '制冷/制热功率',
                            value: '636',
                            unit: 'kW'
                        }, {
                            name: '排气温度',
                            value: '650',
                            unit: '℃'
                        }, {
                            name: '排气流量',
                            value: '2.3',
                            unit: 'kg/s'
                        }, {
                            name: '适用燃料',
                            value: '液体：常规煤柴油、甲乙醇，化工废液\n气体：天然气、氢气等',
                            unit: ''
                        }, {
                            name: '耗油量',
                            value: '178',
                            unit: 'L/h'
                        }, {
                            name: '耗氢量',
                            value: '478.5',
                            unit: 'Nm³/h'
                        }, {
                            name: '热电联产蒸汽量',
                            value: '0.91',
                            unit: 't/h'
                        }, {
                            name: '热电联供效率',
                            value: '81',
                            unit: '%'
                        }, {
                            name: '供冷/供热',
                            value: '11000~25000',
                            unit: 'm³'
                        }, {
                            name: 'NOx',
                            value: '<25ppm/15ppm(无燃料型NOx)',
                            unit: ''
                        }, {
                            name: '噪声',
                            value: '<85',
                            unit: 'db'
                        }, {
                            name: '外型尺寸',
                            value: '6000X2400X2800',
                            unit: 'mm'
                        }, {
                            name: '重量',
                            value: '7',
                            unit: 't'
                        },

                    ]
                },
                burner: {
                    importance: true,
                    all: false,
                    activeName: '产品介绍',
                    previousName: '产品介绍',
                    allParameters: [
                        {
                            model: 'TH-BG-100',
                            name: '单头燃烧器\n额定负荷\n(项目定制)',
                            value: '100',
                            unit: 'kW'
                        }, {
                            model: 'TH-BG-100',
                            name: '对应锅炉',
                            value: '定制',
                            unit: ''
                        }, {
                            model: 'TH-BG-100',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Nm³'
                        }, {
                            model: 'TH-HEG-75',
                            name: ' 燃烧器额定负荷',
                            value: '4.5',
                            unit: 'MW'
                        }, {
                            model: 'TH-HEG-75',
                            name: '对应锅炉',
                            value: '6',
                            unit: 't/h'
                        }, {
                            model: 'TH-HEG-75',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        }, {
                            model: 'TH-HEG-150',
                            name: ' 燃烧器额定负荷',
                            value: '7.5',
                            unit: 'MW'
                        }, {
                            model: 'TH-HEG-150',
                            name: '对应锅炉',
                            value: '10',
                            unit: 't/h'
                        }, {
                            model: 'TH-HEG-150',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        }, {
                            model: 'TH-HEG-225',
                            name: ' 燃烧器额定负荷',
                            value: '22.5',
                            unit: 'MW'
                        }, {
                            model: 'TH-HEG-225',
                            name: '对应锅炉',
                            value: '30',
                            unit: 't/h'
                        }, {
                            model: 'TH-HEG-225',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        },
                    ]
                },
                electrical: {
                    importance: true,
                    all: false,
                    activeName: '产品介绍',
                    previousName: '产品介绍',
                    allParameters: [
                        {
                            name: '额定功率',
                            value: '20',
                            unit: 'kW'
                        }, {
                            name: '额定转矩',
                            value: '1.36',
                            unit: 'N·m'
                        }, {
                            name: '额定转速',
                            value: '140000',
                            unit: 'r/min'
                        }, {
                            name: '效率',
                            value: '≥97.5%',
                            unit: ''
                        }, {
                            name: '重量',
                            value: '4.2',
                            unit: 'kg'
                        }, {
                            name: '包络尺寸',
                            value: '150*150*160',
                            unit: 'mm'
                        }
                    ]
                },
                motor: {
                    importance: true,
                    all: false,
                    activeName: '产品介绍',
                    previousName: '产品介绍',
                    allParameters: [
                        {
                            model: 'TH-BG-100',
                            name: '单头燃烧器\n额定负荷\n(项目定制)',
                            value: '100',
                            unit: 'kW'
                        }, {
                            model: 'TH-BG-100',
                            name: '对应锅炉',
                            value: '定制',
                            unit: ''
                        }, {
                            model: 'TH-BG-100',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        }, {
                            model: 'TH-HEG-75',
                            name: ' 燃烧器额定负荷',
                            value: '4.5',
                            unit: 'MW'
                        }, {
                            model: 'TH-HEG-75',
                            name: '对应锅炉',
                            value: '6',
                            unit: 't/h'
                        }, {
                            model: 'TH-HEG-75',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        }, {
                            model: 'TH-HEG-150',
                            name: ' 燃烧器额定负荷',
                            value: '7.5',
                            unit: 'MW'
                        }, {
                            model: 'TH-HEG-150',
                            name: '对应锅炉',
                            value: '10',
                            unit: 't/h'
                        }, {
                            model: 'TH-HEG-150',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        }, {
                            model: 'TH-HEG-225',
                            name: ' 燃烧器额定负荷',
                            value: '22.5',
                            unit: 'MW'
                        }, {
                            model: 'TH-HEG-225',
                            name: '对应锅炉',
                            value: '30',
                            unit: 't/h'
                        }, {
                            model: 'TH-HEG-225',
                            name: 'Nox排放',
                            value: '≤15',
                            unit: 'mg/Mm³'
                        },
                    ]
                },

            },
            previousIndex: 0,
            currentIndex: 0,
        }
    },
    mounted() {
        this.scrollToDistance()
    },
    methods: {
        scrollToDistance() {
            this.id = this.$route.query.id
            if (this.$refs[this.id]) {
                this.distance = this.$refs[this.id].getBoundingClientRect().top + window.scrollY;
            }
            window.scrollTo({
                top: this.distance,
                behavior: 'smooth'
            });
        },
        handTabClick(event, value) {
            if (value.previousName != value.activeName) {
                value.importance = !value.importance
                value.all = !value.all
                value.previousName = value.activeName
            }
        },
        downFile() {
            const link = document.createElement('a')
            link.style.display = 'none'
            document.body.appendChild(link)

            // 设置文件的 URL 和名称
            link.setAttribute('download', '能源产品手册.pdf')
            link.setAttribute('href', `能源产品手册.pdf`)

            // 模拟点击链接进行下载
            link.click()

            // 移除创建的<a>标签
            document.body.removeChild(link)

        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex % 3 === 0) {
                    return {
                        rowspan: 3,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }
    },
    watch: {
        '$route.params': {
            handler() {
                this.scrollToDistance()
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.background-video {
    position: absolute;
    top: 50%;
    left: 49.9%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 确保视频覆盖整个背景 */
    transform: translate(-50%, -50%);
    z-index: 1;
    // transform: scale(0.9);
    /* 视频置于底层 */
}

.logo {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: space-around;
    flex-wrap: wrap;
    
    .textArea {
        height: 20%;
        width: 100%;
        background-color: rgb(76, 76, 226, 0.5);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-family: QHKT;
        font-weight: bold;
        font-size: 50px;
        color: white;
        z-index: 2;
    }
}

.title {
    height: 100vh;
    width: 100%;
    background-image: url('../../assets/energy/untitled.16.png');
    background-repeat: no-repeat;
    background-size: cover;


    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .textArea {
        height: 20%;
        width: 100%;
        background-color: rgb(76, 76, 226, 0.5);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-family: QHKT;
        font-weight: bold;
        font-size: 50px;
        color: white;
    }
}

::v-deep .custom-tabs {
    .el-tabs__item {
        color: rgb(0, 0, 0);
        font-size: 25px;
        width: 60px;
        line-height: 4vh;
        height: 15vh;
        writing-mode: vertical-rl;
        align-items: center;
        background-color: black;
        color: white;
        transition: all 0.3s
    }

    .el-tabs__item:hover {
        color: rgba(42, 136, 188, 1);
    }

    .el-tabs__item.is-active {
        color: black;
        background-color: white;
        border: 1px solid;
        //border-radius: 30px;
    }

    .el-tabs__header {
        float: center;
        margin-bottom: 0;
        margin-right: 10px;
        margin-top: 20vh;
    }

    .el-tabs__active-bar {
        background-color: transparent;
    }

    .el-tabs__nav-wrap {
        border: 1px solid;
        border-radius: 30px;
    }


}

::v-deep .electrical {
    .el-tabs__content {
        overflow: initial;
    }
}

::v-deep .el-tabs--left .el-tabs__item.is-left {
    display: flex;
    justify-content: center;
}

::v-deep .el-tabs--right .el-tabs__item.is-right {
    display: flex;
    justify-content: center;
}

::v-deep .el-table,
::v-deep .el-table__expanded-cell {
    background-color: transparent !important;

}

/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
    color: white;
    background-color: transparent !important;
    // border: 0; //去除表格
    font-size: 20px;
}

::v-deep .el-table .cell {
    white-space: pre-wrap;
}

// /*去除底边框*/
// ::v-deep.el-table td.el-table__cell {
//     border: 0;
// }

// ::v-deep.el-table th.el-table__cell.is-leaf {
//     border: 0;
// }

/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
    display: none;
}

.energy {
    .ny {
        height: 80vh;
        width: 100%;
        background-color: #000;
        font-family: QHKT;
        color: white;
        margin-top: 2.5vh;
        .paramName {
            color: rgba(42, 136, 188, 1);
        }
    }

    .backgroundVideo {
        width: 100%;
        height: 100%;
    }

    .left {
        width: 45%;
        margin-top: 5%;
        margin-left: 5%;

        .introduce {
            font-size: 50px;
        }

        .parameter {
            margin-top: 10%;
            font-size: 26px;
            width: 90%;

            .parameterContent {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 33%;
                height: 25vh;

                .parameterLine {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    font-size: 25px;
                }
            }

            .parameterContent:hover .icon {
                animation: sway .5s ease-out 0s;
            }
        }

        .parameterTable {
            width: 80%;
            // margin-top: 5%;
        }
    }

    .right {
        width: 35%;

        display: flex;
        flex-direction: column;
        align-items: center;

        .name {
            font-size: 60px;
            font-weight: bold;
            margin-top: 20%;

            .paramModel {
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
        }

        .product {
            height: 50%;
            width: 100%;
            display: flex;
            justify-content: center;
        }

        .downloadButton {
            background-color: rgba($color: #777171, $alpha: 0.5);
            color: white;
            border: none;
            margin-left: 10%;
            margin-top: 1%;
        }


        .downloadButton:hover {
            background-color: #2c2727;
        }
    }

    .turbine {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .burner {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .electrical {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .motor {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }
}

.importance-enter-active {
    transition: all 0.5s;
}

.importance-enter {
    transform: translateY(100%);
    opacity: 0;
}

.all-enter-active {
    transition: all 0.5s;
}

.all-enter {
    transform: translateY(-100%);
    opacity: 0;
}


// .text-enter-active {
//     animation: bounce-in 2s;
// }

// .text-enter {
//     opacity: 0;
// }

.text-enter-active {
    transition: all 2s;
    z-index: 2;
}

.text-enter {
    opacity: 0;
    transform: translateY(-50px);
}

// @keyframes bounce-in {
//     0% {
//         transform: scale(0);
//     }

//     100% {
//         transform: scale(1);
//     }
// }

@keyframes sway {
    33% {
        transform: translateX(-5px);
    }

    66% {
        transform: translateX(5px);
    }

    100% {
        transform: translateX(0px);
    }
}
</style>